import axios from "../api";
/** Saves account settings, as web's profile and My Club setup do. */
export const patchUserSettings = async (settings) => {
    const res = await axios.patch("/users", settings);
    return res.data;
};
//# sourceMappingURL=patchUserSettings.js.map